<!--首页-->
<template>
  <div class="gray-back" style="height: 100%">
    <div class="box"  >
      <!--<div class="row1" v-for="(row,i) in catelist"  v-if="i<3">-->
        <!--<img v-rblink="{name:'NewsList',query:{cate_id:row.id}}" :src="row.pic_url" />-->
      <!--</div>-->
      <div class="row2">
        <div class="imgbg">
          <img   :src="catelist[0].pic_url" />
          <div class="imgbg-btns">
            <div v-rblink="{name:'ExameApplyListMine',query:{}}" class="btn">申报</div>
            <div v-rblink="{name:'NewsList',query:{cate_id:catelist[0].id}}" class="btn">展示</div>
          </div>
        </div>

        <div class="imgbg">
          <img   :src="catelist[1].pic_url" />
          <div class="imgbg-btns">
            <div class="btn" v-rblink="{name: 'LevelApplyList'}">申报记录</div>
          </div>
        </div>

        <!-- <div class="imgbg">
          <img   :src="catelist[2].pic_url" />
          <div class="btn" @click="$toast('正在建设中')">申报</div>
          <div  v-rblink="{}"  @click="$toast('正在建设中')" style="top:80px" class="btn">展示</div>
        </div> -->



        <!-- <div class="imgbg">
          <img   :src="catelist[4].pic_url" />
          <div class="btn" v-rblink="{name:'ClubDetailSihaoApply'}">申报</div>
          <div  v-rblink="{name:'ClubDetailSihaoApplySuccess'}"  style="top:80px" class="btn">展示</div>
        </div> -->
      </div>

    <div class="box row-full">

      <div class="imgbg">
        <img   :src="catelist[3].pic_url" />
        <div class="imgbg-btns">
          <div class="btn" v-rblink="{name: 'AbilityApplyList'}">报名入口</div>
          <!-- <div class="btn" v-rblink="{name: 'AbilityApplyList'}">展示</div> -->
        </div>
      </div>


    </div>


      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">


          <div v-for="(row,i) in list" :key="i" v-rblink="{name:'NewsDetail',query:{id:row.id }}" >
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
  </div>
</template>
<style scoped>

.box {
  background: #f8f8f8;
  padding-bottom: 50px;
  overflow: hidden;
}
  .row1{
    /*padding: 10px;*/
    margin: 0 10px;
  }
  .row1 img{
    width: 100%;
    margin: 10px 0 0 0 ;
  }
  /* 一行 2 个，等分宽度 */
  .row2 {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    box-sizing: border-box;
    margin: 10px 10px 0 10px;
    gap: 10px;
  }
  .row2 .imgbg {
    float: none;
    flex: 1 1 0;
    min-width: 0;
    width: auto;
    margin: 0 0 10px 0;
  }
  /* 一行 1 个，整行通栏 */
  .row-full {
    margin-left: 10px;
    margin-right: 10px;
  }
  .row-full .imgbg {
    float: none;
    width: 100%;
    margin: 0 0 10px 0;
    box-sizing: border-box;
  }
  .imgbg{
    float: left;
    position: relative;
    width: calc(33.33% - 10px);
    margin: 0 10px 10px 0;
  }
  .imgbg img {
    width: 100%;
    display: block;
  }
  /* 覆盖在图上的操作区：整体垂直居中，通栏大卡片略偏下，减少与主标题重叠 */
  .imgbg-btns {
    position: absolute;
    top: 66%;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 14px;
    padding: 0 10px;
    box-sizing: border-box;
    transform: translateY(-50%);
    pointer-events: none;
  }
  .imgbg-btns .btn {
    pointer-events: auto;
    position: static;
    margin: 0;
    text-align: center;
    min-width: 96px;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: 0.03em;
    color: #fff;
    border: 3px solid #fff;
    border-radius: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.12);
  }
  .row2 .imgbg-btns {
    /* 上排两图略压向视觉中下部，按钮更好落在图内主区域 */
    top: 66%;
  }
  .row-full .imgbg-btns {
    /* 大底图常带中上/中部标题，整体略低一点 */
    top: 58%;
  }
  .logo-ul{
    background: #fff;
    border-radius: 10px;
    height: 100px;
    margin: 0 10px;
  }
  .logo-ul div{
    text-align: center;
    float: left;
    width: calc(33.33% - 10px);
    margin: 0 0 10px 10px;
    line-height: 110px;
    height: 110px;
  }
  .logo-ul img{
    width: 100%;
    display: inline-block;
  }

</style>

<script>
import Vue from "vue";
import { Tab, Tabs, List, PullRefresh, Toast } from "vant";

import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import LoginDialog from '@/components/LoginDialog.vue';
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast);

export default {
  name: "NewsList",
  components: {
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    LoginDialog
  },

  data: function() {
    return {
      isLoading: false,
      loading: false,
      finished: false,
      active: 0,
      activeTab: [
      ],
      catelist:[],
      list:[],
      params:{
        cate_id:64,
        pageNo:1,
        pageSize:10
      },
    };
  },
  filters: {
  },
  mounted() {
    document.title = "运动员等级";
    this.params.pageNo = 1;
    this.loading = true;
    this.finished = false;
    let that = this;

    that.$api.get(
            "/api/cms/catelist",{
              parent_id:58
            },
            res => {
              that.catelist = res.data
            },
            res => {
              Toast(res.msg);
            }
    );

    this.fetch();
  },
  destroyed() {},
  methods: {
    fetch() {
      let that = this;
      that.$api.get(
              "/api/cms/cmsList",that.params,
              res => {

                that.loading = false;
                console.log('fetchok')
                if (res.data.currentpage == 1) {
                  that.isLoading = false;
                  that.list = res.data.list;
                } else {
                  that.list = that.list.concat(res.data.list);
                }

                if (res.data.list.length == 0) {
                  that.finished = true;
                }
                that.params.pageNo += 1;
              },
              res => {
                Toast(res.msg);
              }
      );
    },
    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      that.fetch();
    },
    onLoad() {
      // console.log(1)
      // 异步更新数据
      console.log("this.params.pageNo");
      if (this.params.pageNo > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// Yundongyuandengji.vue?04808cb5